// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['nds_DE']  = {
  "name": "nds_DE",
  "day": {
    "abbrev": [
      "Sdag",
      "Maan",
      "Ding",
      "Migg",
      "Dunn",
      "Free",
      "Svd."
    ],
    "full": [
      "Sünndag",
      "Maandag",
      "Dingsdag",
      "Middeweek",
      "Dunnersdag",
      "Freedag",
      "Sünnavend"
    ]
  },
  "month": {
    "abbrev": [
      "Jan",
      "Feb",
      "Mär",
      "Apr",
      "Mai",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dez"
    ],
    "full": [
      "Jannuaar",
      "Feberwaar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%d.%m.%Y",
  "time24": "%T",
  "dateTime": "%a %d. %b %Y %T %Z",
  "time12": ""
}

